// findsecrets-ignore-file
import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/general/purchaseOrdersReportActions'
import * as api from '../../../api/reports/general/purchaseOrders'

function* purchaseOrdersReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.PURCHASE_ORDERS_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.PURCHASE_ORDERS_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* purchaseOrdersReportGetCompaniesList(action) {
  try {
    const payload = yield call(api.getOrganizationList)
    yield put({ type: constants.PURCHASE_ORDERS_REPORT_GET_COMPANIES_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.PURCHASE_ORDERS_REPORT_GET_COMPANIES_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* purchaseOrdersReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.PURCHASE_ORDERS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.PURCHASE_ORDERS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* watchPurchaseOrdersReportGetJobList() {
  yield takeLatest(
    constants.PURCHASE_ORDERS_REPORT_GET_JOB_LIST.ACTION,
    purchaseOrdersReportGetJobList
  )
}

function* watchPurchaseOrdersReportGetCompaniesList() {
  yield takeLatest(
    constants.PURCHASE_ORDERS_REPORT_GET_COMPANIES_LIST.ACTION,
    purchaseOrdersReportGetCompaniesList
  )
}

function* watchPurchaseOrdersReportGetFullReport() {
  yield takeLatest(
    constants.PURCHASE_ORDERS_REPORT_GET_FULL_REPORT.ACTION,
    purchaseOrdersReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchPurchaseOrdersReportGetJobList),
    fork(watchPurchaseOrdersReportGetCompaniesList),
    fork(watchPurchaseOrdersReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/general/purchaseOrdersReportSaga.js